import { Grid } from "@mui/material";
import { RouteComponentProps } from "@reach/router";
import CardHESP from "../../components/CardHESP/CardHESP";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import ManageReportForm from "../../components/Reports/ManageReportForm";
import { GetReportQuery, GetReportQueryVariables } from "./__generated__/GetReportQuery";
import { useQuery } from "react-apollo";
import CentralPageLoader from "../../components/Loading/CentralPageLoader";
import { GET_REPORT_QUERY } from "./CreateReport";

interface Props extends RouteComponentProps {
    organizationId?: string;
    reportId?: string;
}

export default function UpdateReport({ organizationId, reportId }: Props) {
    const { data, loading } = useQuery<GetReportQuery, GetReportQueryVariables>(GET_REPORT_QUERY, {
        variables: {
            reportId: reportId!,
            organizationId: organizationId!,
        },
    });

    if (loading) {
        return <CentralPageLoader text="Getting report info" />;
    }

    if (!data) {
        return <div>An error occurred</div>;
    }

    return (
        <Grid container spacing={{ xs: 5, md: 6 }} justifyContent="center">
            <Grid item xs={12}>
                <SectionTitle title="Create a report" align="left" showBottomBorder />
                <CardHESP>
                    <ManageReportForm organizationId={organizationId!} report={data.report} />
                </CardHESP>
            </Grid>
        </Grid>
    );
}
